<template>
  <div v-bind:style="styles" class="spinner spinner--rotate-square-2"></div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '40px'
    },
    background: {
      type: String,
      default: '#41b883'
    }
  },
  computed: {
    styles () {
      return {
        width: this.size,
        height: this.size
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .spinner {
    position: relative;
    * {
      line-height: 0;
      box-sizing: border-box;
    }
    &:before {
      content: '';
      width: 100%;
      height: 20%;
      min-width: 5px;
      background: #000;
      opacity: 0.15;
      position: absolute;
      bottom: 0;
      left: 3px;
      border-radius: 50%;
      animation: rotate-square-2-shadow .75s linear infinite;
    }
    &:after {
      content: '';
      width: 50px;
      height: 50px;
      background: url("./../../../public/static/img/amui/logo_loader.png") no-repeat;
      animation: rotate-square-2-animate .75s linear infinite;
      transform-origin: center center;
      position: absolute;
      bottom:50%;
      left: 0;
      border-radius: 3px;
    }
  }
  @keyframes rotate-square-2-animate {
    0% {
      transform: translateY(0) scale(1, 1) rotate(0deg);
      border-bottom-right-radius: 3px;
    }
    25% {
      transform: translateY(20%) scale(1, 1) rotate(90deg);
    }
    50% {
      transform: translateY(40%) scale(1, .9) rotate(180deg);
      border-bottom-right-radius: 45%;
    }
    75% {
      transform: translateY(20%) scale(1, 1) rotate(270deg);
    }
    100% {
      transform: translateY(0) scale(1, 1) rotate(360deg);
      border-bottom-right-radius: 3px;
    }
  }
  @keyframes rotate-square-2-shadow {
    0%, 100% {
      transform: scale(1, 1);
    }
    50% {
      transform: scale(1.2, 1);
    }
  }
</style>
